var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.652 9.07682L19.3425 14.8789L13.652 20.681L12.7326 19.7435L16.8395 15.5456H6V14.2122H16.8395L12.7326 10.0143L13.652 9.07682ZM17.7692 4.87891H23V24.8789H17.7692V23.5456H21.6923V6.21224H17.7692V4.87891Z",
    fill: "#367BBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.652 8.57682C13.7863 8.57682 13.915 8.63084 14.009 8.72672L19.6995 14.5288C19.8902 14.7232 19.8902 15.0346 19.6995 15.229L14.009 21.0311C13.915 21.127 13.7863 21.181 13.652 21.181C13.5178 21.181 13.3891 21.127 13.2951 21.0311L12.3756 20.0936C12.1851 19.8993 12.1849 19.5883 12.3752 19.3938L15.6509 16.0456H6C5.72386 16.0456 5.5 15.8217 5.5 15.5456V14.2122C5.5 13.9361 5.72386 13.7122 6 13.7122H15.6509L12.3752 10.364C12.1849 10.1695 12.1851 9.85849 12.3756 9.66422L13.2951 8.72672C13.3891 8.63084 13.5178 8.57682 13.652 8.57682ZM16.8395 14.2122H6V15.5456H16.8395L12.7326 19.7435L13.652 20.681L19.3425 14.8789L13.652 9.07682L12.7326 10.0143L16.8395 14.2122ZM17.2692 4.87891C17.2692 4.60276 17.4931 4.37891 17.7692 4.37891H23C23.2761 4.37891 23.5 4.60276 23.5 4.87891V24.8789C23.5 25.155 23.2761 25.3789 23 25.3789H17.7692C17.4931 25.3789 17.2692 25.155 17.2692 24.8789V23.5456C17.2692 23.2694 17.4931 23.0456 17.7692 23.0456H21.1923V6.71224H17.7692C17.4931 6.71224 17.2692 6.48838 17.2692 6.21224V4.87891ZM21.6923 6.21224V23.5456H17.7692V24.8789H23V4.87891H17.7692V6.21224H21.6923Z",
    fill: "#367BBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseActive);
export default __webpack_public_path__ + "static/media/purchaseActive.7ecad4822f755599c1201e1056965e56.svg";
export { ForwardRef as ReactComponent };